// tanstack
import { useNavigate } from '@tanstack/react-router';

// material ui icons
import LightRoundedIcon from '@mui/icons-material/LightRounded';

// material ui
import { Stack, Typography } from '@mui/material';
import { DataGridPremium } from '@mui/x-data-grid-premium';

const UnitSensorDataGrid = ({ unitSensors }) => {
  const navigate = useNavigate();

  const handleUnitSensorRowClick = (params) => {
    const unitId = params?.row?.UnitId;
    if (!unitId) return;
    navigate({ to: `/$accountId/units/${unitId}` });
  };

  const rows = unitSensors?.map((us) => ({
    id: us.UnitSensorId,
    ChannelNumber: us.ChannelNumber,
    UnitId: us.Unit?.UnitId,
    Name: us.Unit?.Name,
    SensorId: us.SensorId, // if you need it in click handler
  }));

  const sortedRows = rows?.sort((a, b) => a.ChannelNumber - b.ChannelNumber);

  const columns = [
    { field: 'ChannelNumber', headerName: 'Channel', flex: 1 },
    { field: 'Name', headerName: 'Name', flex: 1 },
    {
      field: 'UnitId',
      headerName: 'Unit ID',
      flex: 1,
      renderCell: (params) => {
        const unitId = params.value;
        return (
          <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            sx={{ height: '100%', width: '100%' }}
          >
            <LightRoundedIcon fontSize="small" />
            <Typography variant="body2">{unitId || 'No Unit'}</Typography>
          </Stack>
        );
      },
    },
  ];

  return (
    <DataGridPremium
      rows={sortedRows || []}
      columns={columns}
      hideFooter
      disableRowSelectionOnClick
      autoHeight
      data-testid="sensor-detail-unitsensor-datagrid"
      initialState={{
        sorting: {
          sortMode: [{ field: 'ChannelNumber', sort: 'desc' }],
        },
      }}
      pageSizeOptions={[10, 25, 50]}
      onRowClick={handleUnitSensorRowClick}
      sx={{ cursor: 'pointer' }}
    />
  );
};

export default UnitSensorDataGrid;
